import PropTypes from 'prop-types';
import ViewerContainer from '../viewer/viewerContainer';
import ErrorMessageContainer from './errorMessageContainer';
import Spinner from './spinner';
import { LOADING_PDF, LOADED_PDF, LOAD_PDF_FAILED } from '../../../shared/actions/types';

export default function ViewerLoader({ loadingState }) {
  switch (loadingState) {
    case LOADING_PDF:
      return <Spinner />;
    case LOADED_PDF:
      return <ViewerContainer />;
    case LOAD_PDF_FAILED:
      return <ErrorMessageContainer />;
    default:
      return null;
  }
}

ViewerLoader.propTypes = {
  loadingState: PropTypes
    .oneOf([LOADING_PDF, LOADED_PDF, LOAD_PDF_FAILED])
    .isRequired,
};
